<div class="space-y-6">
  <!-- Header Section -->
  <div class="flex items-center justify-between bg-white p-6 rounded-xl border border-gray-100 shadow-sm">
    <div class="flex items-center space-x-4">
      <div class="p-3 bg-blue-50 rounded-lg text-blue-600">
        <i class="fas fa-layer-group text-xl"></i>
      </div>
      <div>
        <h3 class="text-lg font-bold text-gray-900">Opciones de Cuotas</h3>
        <p class="text-sm text-gray-500">Configura los plazos de pago disponibles para este plan.</p>
      </div>
    </div>
    <button type="button" (click)="openAddModal()"
      class="inline-flex items-center px-5 py-2.5 border border-transparent text-sm font-medium rounded-lg shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all transform hover:scale-105 active:scale-95">
      <i class="fas fa-plus mr-2"></i>
      Agregar Plazo
    </button>
  </div>

  <!-- Empty State -->
  <div *ngIf="paymentTerms.length === 0"
    class="text-center py-16 bg-gray-50 rounded-xl border-2 border-dashed border-gray-200">
    <div class="w-20 h-20 mx-auto bg-white rounded-full flex items-center justify-center shadow-sm mb-4">
      <i class="fas fa-calendar-plus text-gray-300 text-4xl"></i>
    </div>
    <h4 class="text-lg font-medium text-gray-900 mb-1">No hay plazos configurados</h4>
    <p class="text-gray-500 mb-6 max-w-sm mx-auto">Agrega opciones de cuotas para que tus clientes puedan elegir cómo
      pagar.</p>
    <button type="button" (click)="openAddModal()"
      class="text-blue-600 hover:text-blue-800 font-semibold hover:underline">
      Comenzar ahora &rarr;
    </button>
  </div>

  <!-- List of Terms -->
  <div *ngIf="paymentTerms.length > 0" class="grid gap-3 terms-list pr-2">
    <div *ngFor="let term of paymentTerms; let i = index"
      class="group flex items-center justify-between p-4 bg-white border-2 border-gray-200 rounded-lg hover:border-blue-400 hover:shadow-sm transition-all duration-200">

      <div class="flex items-center space-x-4 flex-1">
        <!-- Order Badge -->
        <div
          class="flex items-center justify-center w-8 h-8 bg-blue-100 rounded-full text-blue-700 font-bold text-sm">
          {{ term.order }}
        </div>

        <!-- Info Principal -->
        <div class="flex-1">
          <div class="flex items-baseline gap-2">
            <span class="text-2xl font-bold text-gray-900">{{ term.installments }}</span>
            <span class="text-sm font-semibold text-gray-600 uppercase">{{ term.installments === 1 ? 'Cuota' : 'Cuotas' }}</span>
            <span class="text-gray-400 mx-2">•</span>
            <span class="text-base font-medium text-blue-600">{{ getFrequencyLabel(term) }}</span>
          </div>
        </div>
      </div>

      <!-- Action Button (Solo Eliminar) -->
      <button type="button" (click)="deleteTerm(i)"
        class="p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors group-hover:opacity-100 opacity-60"
        title="Eliminar">
        <i class="fas fa-trash-alt text-lg"></i>
      </button>
    </div>
  </div>
</div>

<!-- Modal -->
<div *ngIf="showModal" class="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog"
  aria-modal="true">
  <!-- Overlay -->
  <div class="flex items-center justify-center min-h-screen px-4 text-center sm:block sm:p-0">
    <div class="fixed inset-0 bg-gray-900 bg-opacity-50 transition-opacity backdrop-blur-md" (click)="closeModal()"
      aria-hidden="true"></div>

    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

    <!-- Modal Panel -->
    <div
      class="modal-panel inline-block align-bottom bg-white rounded-2xl text-left overflow-hidden shadow-2xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl w-full border border-gray-100">

      <!-- Modal Header -->
      <div class="bg-white px-6 py-5 border-b border-gray-100 flex justify-between items-center">
        <div>
          <h3 class="text-xl font-bold text-gray-900" id="modal-title">
            Agregar Plazo
          </h3>
          <p class="text-sm text-gray-500 mt-1">Define las condiciones de pago para esta opción.</p>
        </div>
        <button (click)="closeModal()"
          class="text-gray-400 hover:text-gray-600 hover:bg-gray-100 p-2 rounded-full transition-colors">
          <i class="fas fa-times text-lg"></i>
        </button>
      </div>

      <div class="px-6 py-6 bg-gray-50/30">
        <form [formGroup]="termForm" class="space-y-6">

          <!-- Top Row: Installments & Order -->
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <!-- Installments -->
            <div>
              <label class="block text-sm font-semibold text-gray-700 mb-2">Número de Cuotas</label>
              <div class="relative rounded-md shadow-sm">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <span class="text-gray-500 sm:text-sm">#</span>
                </div>
                <input type="number" formControlName="installments"
                  class="focus:ring-blue-500 focus:border-blue-500 block w-full pl-8 pr-12 sm:text-sm border-gray-300 rounded-lg py-2.5 transition-all duration-200"
                  placeholder="12">
                <div class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                  <span class="text-gray-400 sm:text-xs">pagos</span>
                </div>
              </div>
              <p *ngIf="termForm.get('installments')?.invalid && termForm.get('installments')?.touched"
                class="mt-1 text-xs text-red-600 font-medium">
                Requerido (1-100)
              </p>
            </div>

            <!-- Order -->
            <div>
              <label class="block text-sm font-semibold text-gray-700 mb-2">Orden de Visualización</label>
              <div class="relative rounded-md shadow-sm">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <i class="fas fa-sort-numeric-down text-gray-400 text-xs"></i>
                </div>
                <input type="number" formControlName="order"
                  class="focus:ring-blue-500 focus:border-blue-500 block w-full pl-9 sm:text-sm border-gray-300 rounded-lg py-2.5 transition-all duration-200"
                  placeholder="1">
              </div>
            </div>
          </div>

          <!-- Frequency Selection (Cards) -->
          <div>
            <label class="block text-sm font-semibold text-gray-700 mb-3">Frecuencia de Pago</label>
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">

              <!-- Semanal -->
              <label
                class="frequency-card relative flex items-start p-4 border rounded-xl cursor-pointer bg-white hover:bg-gray-50"
                [class.selected]="termForm.get('frequency')?.value === 'semanal'">
                <div class="flex items-center h-5">
                  <input type="radio" formControlName="frequency" value="semanal"
                    class="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500">
                </div>
                <div class="ml-3">
                  <span class="block text-sm font-bold text-gray-900">Semanal</span>
                  <span class="block text-xs text-gray-500 mt-0.5">Pago cada 7 días</span>
                </div>
                <div class="ml-auto text-blue-500 opacity-0 transition-opacity"
                  [class.opacity-100]="termForm.get('frequency')?.value === 'semanal'">
                  <i class="fas fa-calendar-week text-xl"></i>
                </div>
              </label>

              <!-- Quincenal -->
              <label
                class="frequency-card relative flex items-start p-4 border rounded-xl cursor-pointer bg-white hover:bg-gray-50"
                [class.selected]="termForm.get('frequency')?.value === 'quincenal'">
                <div class="flex items-center h-5">
                  <input type="radio" formControlName="frequency" value="quincenal"
                    class="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500">
                </div>
                <div class="ml-3">
                  <span class="block text-sm font-bold text-gray-900">Quincenal</span>
                  <span class="block text-xs text-gray-500 mt-0.5">Pago cada 15 días</span>
                </div>
                <div class="ml-auto text-blue-500 opacity-0 transition-opacity"
                  [class.opacity-100]="termForm.get('frequency')?.value === 'quincenal'">
                  <i class="fas fa-calendar-alt text-xl"></i>
                </div>
              </label>

              <!-- Mensual -->
              <label
                class="frequency-card relative flex items-start p-4 border rounded-xl cursor-pointer bg-white hover:bg-gray-50"
                [class.selected]="termForm.get('frequency')?.value === 'mensual'">
                <div class="flex items-center h-5">
                  <input type="radio" formControlName="frequency" value="mensual"
                    class="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500">
                </div>
                <div class="ml-3">
                  <span class="block text-sm font-bold text-gray-900">Mensual</span>
                  <span class="block text-xs text-gray-500 mt-0.5">Pago cada 30 días</span>
                </div>
                <div class="ml-auto text-blue-500 opacity-0 transition-opacity"
                  [class.opacity-100]="termForm.get('frequency')?.value === 'mensual'">
                  <i class="fas fa-calendar text-xl"></i>
                </div>
              </label>

              <!-- Días Continuos -->
              <label
                class="frequency-card relative flex items-start p-4 border rounded-xl cursor-pointer bg-white hover:bg-gray-50"
                [class.selected]="termForm.get('frequency')?.value === 'dias_continuos'">
                <div class="flex items-center h-5">
                  <input type="radio" formControlName="frequency" value="dias_continuos"
                    class="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500">
                </div>
                <div class="ml-3">
                  <span class="block text-sm font-bold text-gray-900">Personalizado</span>
                  <span class="block text-xs text-gray-500 mt-0.5">Define los días exactos</span>
                </div>
                <div class="ml-auto text-blue-500 opacity-0 transition-opacity"
                  [class.opacity-100]="termForm.get('frequency')?.value === 'dias_continuos'">
                  <i class="fas fa-clock text-xl"></i>
                </div>
              </label>
            </div>
          </div>

          <!-- Frequency Days (Conditional with Animation) -->
          <div *ngIf="termForm.get('frequency')?.value === 'dias_continuos'"
            class="bg-blue-50 rounded-xl p-4 border border-blue-100 animate-fade-in-down">
            <label class="block text-sm font-semibold text-blue-900 mb-2">Intervalo de días</label>
            <div class="flex items-center">
              <input type="number" formControlName="frequencyDays"
                class="focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-blue-200 rounded-lg py-2.5"
                placeholder="Ej: 45">
              <span class="ml-3 text-sm text-blue-700 font-medium">días entre cada cuota</span>
            </div>
            <p class="mt-2 text-xs text-blue-600">
              <i class="fas fa-info-circle mr-1"></i>
              El cliente deberá realizar un pago cada X días exactos.
            </p>
          </div>

        </form>
      </div>

      <!-- Footer -->
      <div class="bg-gray-50 px-6 py-4 border-t border-gray-100 flex flex-row-reverse gap-3">
        <button type="button" (click)="saveTerm()" [disabled]="termForm.invalid"
          class="inline-flex justify-center rounded-lg border border-transparent shadow-sm px-6 py-2.5 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-all">
          Agregar Plazo
        </button>
        <button type="button" (click)="closeModal()"
          class="inline-flex justify-center rounded-lg border border-gray-300 shadow-sm px-6 py-2.5 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-all">
          Cancelar
        </button>
      </div>
    </div>
  </div>
</div>